/* eslint-disable */
import * as Yup from 'yup';

export const createTravelRequestSchema = Yup.object().shape({
    travelPlanId: Yup.number().required('Please select a trip purpose').positive('Invalid trip purpose selected'),
    files: Yup.array(),
    userIds: Yup.array()
        .of(Yup.string().required('Please select a traveller'))
        .min(1, 'At least one traveller must be selected')
        .test('unique-users', 'Each traveller must be unique', (value) => {
            const uniqueUsers = new Set(value.filter(Boolean));
            return uniqueUsers.size === value.filter(Boolean).length;
        }),
    budgetLine: Yup.number().required('Please select a budget line').positive('Invalid budget line selected'),
    travelType: Yup.string().required('Travel type is required'),
    branchCode: Yup.string()
        .required('Please select a branch code')
        .test('valid-branch', 'Selected branch code is invalid', (value) => Boolean(value)),
    projectCode: Yup.string()
        .required('Please select a project code')
        .test('valid-project', 'Selected project code is invalid', (value) => Boolean(value)),
    departureDatetime: Yup.date()
        .required('Please specify departure date and time')
        .test('valid-departure', 'Return time must be after departure time', function (value) {
            if (!value) return false;
            const returnTime = this.parent.returnDatetime;
            if (!returnTime) return true;

            return new Date(returnTime) > new Date(value);
        }),
    returnDatetime: Yup.date()
        .required('Please specify return date and time')
        .test('min-duration', 'Trip duration must be at least 1 hour', function (value) {
            if (!value || !this.parent.departureDatetime) return true;

            const duration = (new Date(value) - new Date(this.parent.departureDatetime)) / (1000 * 60 * 60);
            return duration >= 1;
        }),
    travellersCount: Yup.number()
        .required('Number of travellers is required')
        .min(1, 'At least one traveller is required')
        .max(20, 'Maximum 20 travellers allowed')
        .integer('Must be a whole number')
}); 